import fonts from './_fonts'

export default function () {
  const els = document.querySelectorAll('[data-clamp]')

  if (els.length) {
    Promise.all([import('shave'), fonts.sofia.bold.load()]).then(values => {
      const shave = values[0].default

      for (let i = 0; i < els.length; i++) {
        const lineHeight = window.getComputedStyle(els[i]).getPropertyValue('line-height')
        const maxHeight = (parseFloat(lineHeight) * parseFloat(els[i].getAttribute('data-clamp'))) + 2
        shave(els[i], parseInt(maxHeight, 10))
      }
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/_clamp.js